import { ref, watch } from 'vue';
import type { Ref } from 'vue';
import type { HeaderProps, NotificationBannerProps } from '@/types/shared-types';
import { useLocalStorage } from '@vueuse/core';

const StorageKey = 'miele-notification-dismissed';
const BodyNotificationClass = 'dhf-notification-on';
const DefaultNotificationData: NotificationBannerProps = {
    title: '',
    copy: '',
};

export default function useNotificationState(navData: Ref<HeaderProps | undefined>) {
    const bodyEl = ref<HTMLElement>(document.getElementsByTagName('body')[0]);
    const isNotificationVisible = ref<boolean>(false);
    const notificationData = ref<NotificationBannerProps>(DefaultNotificationData);
    const hasUserDismissed = useLocalStorage(StorageKey, false);

    const enableNotification = () => {
        isNotificationVisible.value = true;
        bodyEl.value?.classList.add(BodyNotificationClass);
    };

    watch(navData, () => {
        if (navData.value?.notificationBanner?.title?.length) {
            notificationData.value = { ...navData.value.notificationBanner };
            if (!hasUserDismissed.value) enableNotification();
        }
    });

    const onDismissNotification = () => {
        bodyEl.value?.classList.remove(BodyNotificationClass);
        hasUserDismissed.value = true;
        return hasUserDismissed.value;
    };

    return {
        isNotificationVisible,
        notificationData,
        onDismissNotification,
    };
}
